import styled from 'styled-components';

export const InputFileContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    width: 100%;
    min-height: 200px;
    border: 1px dashed #ddd;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ddd;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;

    :hover {
      opacity: 0.6;
    }

    img {
      max-width: 100%;
      border-radius: 10%;
    }

    input {
      display: none;
    }
  }
`;
